import React from "react";
import IconTitleContent from "../ui/card/IconTitleContent";
import styles from "../../../CSS/sections/AboutUsBanner.module.css";

const Col3Cards = ({ content }) => {
  const { title, cards } = content;
  const cardStyles = {
    background:
      "linear-gradient(0deg, rgba(0, 0, 0, 0.55) 0%, rgba(0, 0, 0, 0.55) 100%), linear-gradient(0deg, #4B5D3C 0%, #4B5D3C 100%), lightgray -629.408px 0px / 226.772% 100% no-repeat",
    borderRadius: "20px",
    padding: "32px 24px",
    height: "100%",
  };

  const iconStyles = {
    width: "56px",
    height: "56px",
    justifyContent: "center",
    alignItems: "center",
  };

  // const iconDescription = {

  // }

  return (
    <section className={`padding-y`} style={{ backgroundColor: "#F5F3F0" }}>
      <div className="container">
        <div className={`${styles.rowCustom} row`}>
          <div className="col-12 col-lg-10 offset-lg-1 text-center">
            <h2
              className={`${styles.heading2} text-dark`}
              style={{ marginBottom: "40px" }}
            >
              {title}
            </h2>
          </div>
        </div>
        <div className={`${styles.rowCustom} row`}>
          {cards.map((card, idx) => (
            <div className="col-12 col-md-6 col-lg-4 mb-4" key={idx}>
              <IconTitleContent
                content={card}
                cardStyle={cardStyles}
                textColor="text-light"
                iconStyles={iconStyles}
                iconDescriptionStyles={styles}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Col3Cards;